module.exports = __webpack_public_path__ + "static/media/bunkey-avatar-19.51811747.png";